import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index.tsx';

function App() {
  const basename = __BASE_PATH__ === '/' ? '' : __BASE_PATH__;

  return (
    <BrowserRouter basename={basename}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
